import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseSubscriberAdsComponent } from '../../abstract-components/base-subscriber-ads.component';

@Component({
  selector: 'subscriber-ads-layout',
  standalone: false,
  templateUrl: './subscriber-ads-layout.component.html',
  styleUrl: './subscriber-ads-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriberAdsLayoutComponent extends BaseSubscriberAdsComponent {}
